import { render, staticRenderFns } from "./PeriodsChart.vue?vue&type=template&id=07acc97e&"
import script from "./PeriodsChart.vue?vue&type=script&lang=js&"
export * from "./PeriodsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports